/**
 * @file
 * @prettier
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializeRTSStep1Page() {
  customValidationInit(false);
  aspControlValidationInit();
}
